/**
 * Tab Con errores (pedido KP 14/09): primero el bloque "Necesita tu atención"
 * (qué pasó, por qué, qué hacer, botón de reintento) y debajo la tabla de los
 * ingresos con algo fallado. Antes el bloque vivía arriba de Proceso y
 * empujaba la tabla para abajo aunque no hubiera nada que hacer.
 */

import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { WinclapLoader } from '@/components/ui/winclap-loader';
import { AltasTable } from './AltasTable';
import { NeedsAttention } from './NeedsAttention';
import { usePeopleFlowRows } from './usePeopleFlowRows';

export function OnboardingErrorsTab() {
  const { t } = useTranslation();
  const { rows, buckets, statuses, isLoading, error } = usePeopleFlowRows();

  if (isLoading) return <WinclapLoader />;
  if (error) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t('users.people_panel.load_error')}</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-4">
      <NeedsAttention rows={statuses} />
      <AltasTable
        rows={buckets.errors}
        allRows={rows}
        emptyText={t('users.people_panel.errors.empty')}
      />
    </div>
  );
}
